import { Link } from 'react-router-dom';
import { comics, latestComicIds } from '@/mocks/comics';

export default function LatestSection() {
  const latest = latestComicIds.map((id) => comics.find((c) => c.id === id)!);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">最新更新</h2>
            <p className="text-sm text-foreground-500 mt-2">实时追踪热门漫画最新话</p>
          </div>
          <Link
            to="/category/all"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {latest.slice(0, 9).map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200 transition-colors"
            >
              <div className="w-16 h-20 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 最新更新`}
                  title={`${comic.title} 最新章节 | 土豪漫画网`}
                  className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                  {comic.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span
                    className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${
                      comic.category === '韩漫'
                        ? 'bg-primary-100 text-primary-700'
                        : comic.category === '日漫'
                        ? 'bg-accent-100 text-accent-800'
                        : comic.category === '国漫'
                        ? 'bg-secondary-100 text-secondary-800'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {comic.category}
                  </span>
                  <span className="text-[11px] text-foreground-400">{comic.updatedAt}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1.5 truncate">
                  最新：{comic.chapters[comic.chapters.length - 1]?.title || '暂无更新'}
                </p>
              </div>

              <div className="flex-shrink-0">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-primary-100 transition-colors">
                  <i className="ri-arrow-right-s-line text-foreground-500 group-hover:text-primary-500 text-lg"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}